import React from 'react';

import styles from './styles.css';

const ContentSection = ({ copy, headline, image }) => (
  <div className={styles.container}>
    <div className={styles.grid}>
      {image && (
        <img src={image.src} alt={image.alt} className={styles.image} />
      )}
      {headline && <h4 className={styles.headline}>{headline}</h4>}
      {copy && (
        <div
          className={styles.copyContainer}
          dangerouslySetInnerHTML={{ __html: copy }}
        />
      )}
    </div>
  </div>
);

export default ContentSection;



// WEBPACK FOOTER //
// ./src/components/ContentSection/index.js